export const getType = (permit) => {
  switch (permit) {
    case 'official-receipt':
      return 'OFFICIAL_RECEIPT';
    case 'soa':
      return 'SOA_RECEIPT';
    case 'barangay-clearance':
      return 'BARANGAY_CLEARANCE';
    case 'retirement-templates':
      return 'BUSINESS_RETIREMENT_TEMPLATES';
    default:
      return 'BUSINESS_PERMITS';
  }
};

export const getManagePermission = (permit) => {
  switch (permit) {
    case 'official-receipt':
      return 'MANAGE TEMPLATE OFFICIAL RECEIPTS';
    case 'soa':
      return 'MANAGE TEMPLATE STATEMENT OF ACCOUNTS';
    case 'barangay-clearance':
      return 'MANAGE TEMPLATE BARANGAY BUSINESS CLEARANCES';
    case 'retirement-templates':
      return 'MANAGE TEMPLATE RETIREMENT TEMPLATES';
    default:
      return 'MANAGE TEMPLATE BUSINESS PERMITS';
  }
};
